import { render, staticRenderFns } from "./AITokenStats.vue?vue&type=template&id=0d861717&"
import script from "./AITokenStats.vue?vue&type=script&lang=js&"
export * from "./AITokenStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports